import { FormData } from '../../pages/incidents/Incidents'
import { BASE_URL } from '../endpoints'
import { del, get, patch, post } from '../https'

export const getAllIncidents = (
  // page: number,
  sortBy: string,
  sortOrderValue: string
): Promise<unknown> => {
  return get(
    `${BASE_URL}/incidents/invitations?sortBy=${sortBy}&sortOrder=${sortOrderValue}`
  )
}

export const getIncidentById = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/incidents/invitations/${id}`)
}
export const createIncident = (data: FormData): Promise<unknown> => {
  return post(`${BASE_URL}/incidents/my`, data, null)
}

export const updateIncident = (
  data: FormData,
  id: string
): Promise<unknown> => {
  return patch(`${BASE_URL}/incidents/invitations/${id}/incident`, data, null)
}

export const deleteIncident = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/incidents/invitations/${id}/incident`, null)
}

export const getAllSchoolMembers = (): Promise<unknown> => {
  return get(`${BASE_URL}/school-members/admins`)
}
